import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  '@media (max-width: 1250px)': {
    '@global': {
      '*::-webkit-scrollbar': {
        width: '0.4em'
      },
      '*::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
      },
      '*::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.1)',
        outline: '1px solid slategrey'
      }
    }
  },
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1)
    }
  },
  paper: {
    boxShadow: 'none!important',
    border: '0px solid #ddd',
    maxWidth: '1200px',
    margin: '0 auto',
    backgroundColor: 'transparent'
  },
  form: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '600px'
  },
  viewColorLeft: {
    padding: '0px 15px 15px 15px',
    backgroundColor: 'transparent'
  },
  displayResult: {
    padding: '15px',
    backgroundColor: '#8F0904',
    '@media (max-width: 1000px)': {
      padding: '15px 5px 15px 5px'
    }
  },
  headingText: {
    '@media (max-width: 1200px)': {
      lineHeight: '1rem!important'
    }
  },

  wrapButtonView: {
    display: 'flex',
    justifyContent: 'center'
  },
  SelectType: {
    flexGrow: 5,
    backgroundColor: '#CACDD3',
    color: '#000',
    margin: '5px',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#000'
    }
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
    display: 'flex',
    backgroundColor: '#fff'
  },
  fileInputColorCode: {
    width: '97%',
    margin: '10px 0',
    display: 'flex',
    backgroundColor: '#fff',
    '@media (max-width: 680px)': {
      width: '80px!important',
      margin: '4px!important'
    }
  },
  fileInputName: {
    width: '97%',
    margin: '10px 0',
    display: 'flex',
    backgroundColor: '#fff',
    '@media (max-width: 680px)': {
      width: '80px!important',
      margin: '4px!important'
    }
  },
  fileInputVolume: {
    width: '97%',
    margin: '10px 0',
    display: 'flex',
    backgroundColor: '#fff',
    '@media (max-width: 680px)': {
      width: '100px!important',
      margin: '4px!important'
    }
  },
  fileInputTotal: {
    width: '97%',
    margin: '10px 0',
    display: 'flex',
    backgroundColor: '#fff',
    '@media (max-width: 680px)': {
      width: '85px!important',
      margin: '4px!important'
    }
  },
  formControlFile: { width: '85%' },
  CircularProgressbar: { width: '15%' },
  buttonSubmit: {
    marginBottom: 10
  },
  buttonSearch: {
    top: '11px',
    position: 'absolute',
    width: '70px',
    right: '2px',
    height: '50px',
    padding: '0 10px'
  },
  hiddenInput: {
    display: 'none'
  },
  fileInput: {
    width: '100%',
    margin: '10px 0',
    display: 'flex',
    marginLeft: '0px!important',
    backgroundColor: '#fff',
    boxShadow: '1px 1px 1px  #B5132B'
  },
  datePicker: { marginLeft: '0px!important' },
  buttonSubmit: {
    marginBottom: 10
  },
  formControl: {
    marginTop: '10px',
    color: '#000'
  },
  formControl2: {
    marginTop: '10px',
    color: '#000'
  },

  wrapSendBox: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%'
  },
  phoneNumberGroup: {
    display: 'flex'
  },
  firstDivision: {
    display: 'flex',
    flex: 1
  },
  addBtn: {
    backgroundColor: 'transparent',
    border: '0px',
    color: 'green',
    margin: 0
  },
  removeBtn: {
    backgroundColor: 'transparent',
    border: '0px',
    color: 'red',
    margin: 0
  },
  secondDivision: {
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    display: 'flex'
  },
  buttonLink: {
    backgroundColor: '#b5131b',
    color: '#fff',
    marginTop: '10px',
    boxShadow:
      '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#000'
    }
  },
  fixedForm: {
    position: 'fixed',
    bottom: '7%',
    left: '6%',
    width: '165px',
    background: '#b5131b',
    padding: '5px 10px',
    borderRadius: '5px',
    zIndex: '999',
    '@media (max-width: 1000px)': {
      position: 'relative',
      bottom: '0',
      left: '0'
    }
  }
}))
